import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const summaryDetailsDefaultVariants = {}
const summaryDetailsCompoundVariants = []

const summaryDetailsSlotNames = [
  [
    "root",
    "summary-details__root"
  ],
  [
    "title",
    "summary-details__title"
  ],
  [
    "contentWrapper",
    "summary-details__contentWrapper"
  ],
  [
    "separator",
    "summary-details__separator"
  ],
  [
    "list",
    "summary-details__list"
  ]
]
const summaryDetailsSlotFns = /* @__PURE__ */ summaryDetailsSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, summaryDetailsDefaultVariants, getSlotCompoundVariant(summaryDetailsCompoundVariants, slotName))])

const summaryDetailsFn = memo((props = {}) => {
  return Object.fromEntries(summaryDetailsSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const summaryDetailsVariantKeys = []
const getVariantProps = (variants) => ({ ...summaryDetailsDefaultVariants, ...compact(variants) })

export const summaryDetails = /* @__PURE__ */ Object.assign(summaryDetailsFn, {
  __recipe__: false,
  __name__: 'summaryDetails',
  raw: (props) => props,
  variantKeys: summaryDetailsVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, summaryDetailsVariantKeys)
  },
  getVariantProps
})